import { isBefore, parseISO } from "date-fns";
export const competitionApplicationsMixin = {
  computed: {
    assessors() {
      if (this.state.assessors) return this.state.assessors;
      return this.state.competition.assessors;
    },
    applications() {
      return this.state.applications;
    },
    invitedApplications() {
      return this.applications.filter(application => {
        if (!application.rejected_at && application.invited_at)
          return application;
      });
    },
    rejectedApplications() {
      return this.applications.filter(application => {
        if (application.rejected_at) return application;
      });
    },
    submittedApplications() {
      return this.applications.filter(application => {
        if (
          application.submitted_at &&
          !application.rejected_at &&
          !application.invited_at
        )
          return application;
      });
    },
    assessableApplications() {
      return this.applications
        .filter(application => {
          if (application.submitted_at) return application;
        })
        .sort((a, b) => {
          return a.submitted_at > b.submitted_at ? 1 : -1;
        });
    },
    draftApplications() {
      return this.applications.filter(application => {
        if (!application.submitted_at && application.application)
          return application;
      });
    },
    notStartedApplications() {
      return this.applications.filter(application => {
        if (!application.application) return application;
      });
    },
    applicants() {
      return this.applications.reduce((obj, application) => {
        const u = application.user;
        obj[application.uuid] = {
          name: u.name,
          email: u.email,
          company: u.company.name
        };
        return obj;
      }, {});
    },
    applicationOpen() {
      if (!this.state.competition.application_end_date) return false;
      return isBefore(
        new Date(),
        parseISO(this.state.competition.application_end_date)
      );
    }
  },
  methods: {
    // Application Methods
    applicationTitle(application) {
      let APP = application;
      // check if UUID
      if (typeof application === "string") {
        APP = this.applications.find(application => application.uuid === APP);
      }
      if (APP.title) {
        return `[${APP.ref}] ${APP.title}`;
      } else {
        return APP.ref;
      }
    },
    // Applicant Methods
    getApplicant(uuid, value) {
      return this.applicants[uuid][value];
    }
  }
};
